import extractDomain from 'extract-domain';
import Cookies from 'js-cookie';

const KEY = 'affiliation';
const EXPIRY_DAYS = 90;

const cookieDomain = window.location.hostname.includes('.') ? '.' + extractDomain(window.location.hostname) : window.location.hostname;

export const retrieveParams = () => {
  const currentParams = extractParams();

  if (currentParams) {
    saveParams(currentParams);
    return currentParams;
  }

  return retrieveSavedParams();
};

const extractParams = () => {
  const params = new URLSearchParams(window.location.search);
  const trackingParams = {
    source: (params.get('utm_source') || '').toLowerCase(),
    code: null,
    query: window.location.search,
  };

  if (params.get('gclid')) {
    trackingParams.source = 'google';
    trackingParams.code = params.get('gclid');

    return trackingParams;
  }

  switch (trackingParams.source) {
    case 'affiliate':
      trackingParams.source = 'adservice';
      trackingParams.code = params.get('coid');
      return trackingParams;
    case 'adtraction':
      trackingParams.code = params.get('at_gd');
      return trackingParams;
    case 'ilona':
      trackingParams.code = params.get('utm_campaign');
      return trackingParams;
    default:
      return null;
  }
};

const saveParams = (value) => {
  Cookies.set(KEY, JSON.stringify(value), { expires: EXPIRY_DAYS, path: '/', domain: cookieDomain });
};

const retrieveSavedParams = () => {
  if (Cookies.get(KEY)) {
    return JSON.parse(Cookies.get(KEY));
  }
  return null;
};